import {useParams} from 'react-router-dom'
import {KTIcon, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useEffect, useState} from 'react'
import {useLazyQuery} from '@apollo/client'
import {GET_ONE_USERS} from '../../graphql/queries/usersQuery'
import {toast} from 'react-toastify'
import {IResOneUser} from '../../graphql/types/usersTypes'
import moment from 'moment'
import {LoadingOneUser} from './components/LoadingOneUser'
import {ResumenOneUser} from './components/ResumenOneUser'
import {SecurityOneUser} from './components/SecurityOneUser'
import {ModalActiveInactive} from './components/ModalActiveInactive'
import {useDisclosure} from '../../hooks/useDisclosure'
import {ActivityTab} from './components/ActivityTab'

type TTabs = 'RESUME' | 'SECURITY' | 'ACTIVITY'

export const OneUserPage = () => {
  const [gqlGetUser, {data, error, loading, refetch}] = useLazyQuery<IResOneUser>(GET_ONE_USERS, {
    fetchPolicy: 'no-cache',
  })
  const {id} = useParams()

  const [tab, setTab] = useState<TTabs>('RESUME')

  const {isOpen, onClose, onOpen} = useDisclosure()

  useEffect(() => {
    if (isNaN(Number(id))) {
      toast.error('Error: no es posible ver información')
      return
    }
    gqlGetUser({
      variables: {
        id,
      },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  useEffect(() => {
    if (error) toast.error(`Error: ${error.message}`)
  }, [error])

  if (!data || loading) {
    return <LoadingOneUser />
  }

  const user = data?.listUsers?.edges?.[0]?.node

  if (!user) {
    return <div>Usuario no encontradop</div>
  }

  return (
    <div>
      <header className='card mb-2 mb-xl-4'>
        <div className='card-body pt-9 pb-0'>
          <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
            <div className='me-7 mb-4'>
              <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
                <img src={toAbsoluteUrl('/media/almamotors/user-placeholder.webp')} alt='user' />
                <div
                  className={`position-absolute translate-middle bottom-0 start-100 mb-6 bg-${
                    user.isActive ? 'success' : 'danger'
                  } rounded-circle border border-4 border-white h-20px w-20px`}
                ></div>
              </div>
            </div>

            <div className='flex-grow-1'>
              <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                <div className='d-flex flex-column'>
                  <div className='d-flex align-items-center mb-2'>
                    <span className='text-gray-800 text-hover-primary fs-2 fw-bolder me-1'>
                      {user.firstName} {user.lastName}
                    </span>
                    {/* <a href='/#'>
                      <KTIcon iconName='verify' className='fs-1 text-primary' />
                    </a> */}
                  </div>

                  <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                    <span className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'>
                      <KTIcon iconName='profile-circle' className='fs-4 me-1' />
                      {user.currentRol.name}
                    </span>
                    <span
                      className='d-flex align-items-center text-hover-primary me-5 mb-2'
                      style={{
                        color: user.isActive ? 'green' : 'red',
                      }}
                    >
                      <KTIcon
                        iconName={user.isActive ? 'check' : 'cross'}
                        className={`fs-3 me-1 text-${user.isActive ? 'success' : 'danger'}`}
                      />
                      {user.isActive ? 'ACTIVO' : 'INACTIVO'}
                    </span>
                    <span className='d-flex align-items-center text-gray-400 text-hover-primary mb-2'>
                      <KTIcon iconName='sms' className='fs-4 me-1' />
                      {user.email}
                    </span>
                  </div>
                </div>

                <div className='d-flex my-4'>
                  {/* <a href='/#' className='btn btn-sm btn-light me-2' id='kt_user_follow_button'>
                    <KTIcon iconName='check' className='fs-3 d-none' />

                    <span className='indicator-label'>Follow</span>
                    <span className='indicator-progress'>
                      Please wait...
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  </a> */}
                  <button
                    className={`btn btn-sm ${user.isActive ? 'btn-danger' : 'btn-primary'} me-3`}
                    onClick={onOpen}
                  >
                    {user.isActive ? 'Desactivar' : 'Activar'}
                  </button>
                  {/* <div className='me-0'>
                    <button
                      className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                      data-kt-menu-trigger='click'
                      data-kt-menu-placement='bottom-end'
                      data-kt-menu-flip='top-end'
                    >
                      <i className='bi bi-three-dots fs-3'></i>
                    </button>
                    <Dropdown1 />
                  </div> */}
                </div>
              </div>

              <div className='d-flex flex-wrap flex-stack'>
                <div className='d-flex flex-column flex-grow-1 pe-8'>
                  <div className='d-flex flex-wrap'>
                    <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                      <div className='d-flex align-items-center'>
                        {/* <KTIcon iconName='arrow-up' className='fs-3 text-success me-2' /> */}
                        <div className='fs-2 fw-bolder ms-5'>{user.groups.edges.length}</div>
                      </div>

                      <div className='fw-bold fs-6 text-gray-400'>Grupos</div>
                    </div>

                    <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                      <div className='d-flex align-items-center'>
                        {/* <KTIcon iconName='arrow-down' className='fs-3 text-danger me-2' /> */}
                        <div className='fs-2 fw-bolder ms-5'>
                          {user.identityvalidationSet.edges.length}
                        </div>
                      </div>

                      <div className='fw-bold fs-6 text-gray-400'>Validaciones</div>
                    </div>

                    {user.inactivationDate && !user.isActive && (
                      <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                        <div className='d-flex align-items-center'>
                          {/* <KTIcon iconName='arrow-up' className='fs-3 text-success me-2' /> */}
                          <div className='fs-2 fw-bolder'>
                            {moment(user.inactivationDate).format('DD MMM YYYY')}
                          </div>
                        </div>

                        <div className='fw-bold fs-6 text-gray-400'>Inactivo</div>
                      </div>
                    )}
                  </div>
                </div>

                <div className='d-flex align-items-center w-200px w-sm-300px flex-column mt-3'>
                  <div className='d-flex justify-content-between w-100 mt-auto mb-2'>
                    <span className='fw-bold fs-6 text-gray-400'>Último incio de sesión</span>
                    <span className='fw-bolder fs-6'>
                      {user.lastLogin ? moment(user.lastLogin).fromNow() : 'N/R'}
                    </span>
                  </div>
                  {/* <div className='h-5px mx-3 w-100 bg-light mb-3'>
                    <div
                      className='bg-success rounded h-5px'
                      role='progressbar'
                      style={{width: '50%'}}
                    ></div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>

          <div className='d-flex overflow-auto h-55px'>
            <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
              <li className='nav-item'>
                <button
                  className={`btn-reset nav-link text-active-primary me-6 ${
                    tab === 'RESUME' ? 'active' : ''
                  }`}
                  onClick={() => {
                    setTab('RESUME')
                  }}
                >
                  Resumen
                </button>
              </li>
              <li className='nav-item'>
                <button
                  className={`btn-reset nav-link text-active-primary me-6 ${
                    tab === 'ACTIVITY' ? 'active' : ''
                  }`}
                  onClick={() => {
                    setTab('ACTIVITY')
                  }}
                >
                  Actividad
                </button>
              </li>
              <li className='nav-item'>
                <button
                  className={`btn-reset nav-link text-active-primary me-6 ${
                    tab === 'SECURITY' ? 'active' : ''
                  }`}
                  onClick={() => {
                    setTab('SECURITY')
                  }}
                >
                  Seguridad
                </button>
              </li>
            </ul>
          </div>
        </div>
      </header>

      {tab === 'RESUME' && <ResumenOneUser user={user} refetch={refetch} />}
      {tab === 'ACTIVITY' && <ActivityTab refetch={refetch} user={user} />}
      {tab === 'SECURITY' && <SecurityOneUser id={user.id} refetch={refetch} />}

      {isOpen && (
        <ModalActiveInactive
          isOpen={isOpen}
          onClose={onClose}
          isActive={user.isActive}
          id={user.id}
          refetch={refetch}
        />
      )}
    </div>
  )
}
